module.exports = __webpack_public_path__ + "NanumSquareL.fa92696350da81f5da13";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareL.woff
// module id = ../../../../../src/assets/font/NanumSquareL.woff
// module chunks = styles